import {Component, Input, OnInit} from '@angular/core';
import {Dossiers, StateEnum} from '../../../common/services';
import {RoleHelper, rolesDar} from '../../../common/services/roles';
import {Observable, of} from 'rxjs';
import {LdapUser} from '@Services/ldap/ldap/ldap-user.model';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {DarDossiersService} from '../../../common/services/dossiers/dossiers.service';
import {SubSink} from '@Common/core/utils/subsink';
import {Individu, IndividuService} from '@Common/core/services';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {MatDialog} from '@angular/material/dialog';
import {concatMap, filter, finalize, switchMap, tap} from 'rxjs/operators';


/**
 * Les contacts sont manipulés en ajout / suppression par
 * - le demandeur ou un des contacts : au stade création (il ne pourra pas l'éditer au-delà de ce stade de toute façon)
 * - le Gestionnaire ou Admin
 */
@Component({
  selector: 'app-contacts-dar',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
  @Input() dossier: Dossiers;
  @Input() rolesConnecte: rolesDar[];
  @Input() individuConnected: Individu;
  subSink = new SubSink();
  constructor(private dialog: MatDialog,
              private snackSvc: SnackBarToastyService,
              public dossierSvc: DarDossiersService,
              private individuService: IndividuService) { }
  ngOnInit(): void {
  }
  getTitleContact(edit_mode = false) {
    if (this.ownerOrContactCanEditContacts() || edit_mode) {
      return 'Contacts: si vous souhaitez ajouter ou supprimer des contacts, cliquer pour afficher/masquer cette gestion.';
    } else {
      return 'Contacts: si vous souhaitez voir la liste des contacts, cliquer pour afficher/masquer cette gestion.';
    }
  }
  /**
   * Demandeur | Contact
   * L'état du dossier permet-il de toucher aux contacts ?
   */
  ownerOrContactCanEditContacts() {
    return (this._isOwner() || this._isContact()) && this.dossier.state === StateEnum.demande;
  }
  private _isOwner() {
    return this.dossier?.individu?.uid === this.individuConnected?.uid;
  }
  private _isContact() {
    return this.dossier?.contacts.find(uid => uid === this.individuConnected?.uid);
  }
  private _isOwnerOrContact() {
    return this._isOwner() || this._isContact();
  }
  /**
   * Le rôle permet-il de toucher aux contacts ?
   */
  hasRoleForEditContactAsync(): Observable<boolean> {
    return this._hasRoleAsync(rolesDar.gestionnaire) || this._hasRoleAsync(rolesDar.admin);
  }
  private _hasRoleForEditContact(): boolean {
    return RoleHelper.hasRole(rolesDar.gestionnaire) || RoleHelper.hasRole(rolesDar.admin);
  }
  private _hasRoleAsync(role: rolesDar): Observable<boolean> {
    return RoleHelper.hasRoleConnecteAsync(role, this.rolesConnecte);
  }

  /**
   * Ajout LDAP user au contact
   * on ne peut s'auto ajouter aux contacts
   * @param ldapUser
   */
  onSelectContact(ldapUser: LdapUser) {
    const uid = ldapUser.uid[0];
    if ((! this._isOwnerOrContact() ||
        (! this._hasRoleForEditContact())) && this.individuConnected?.uid !== uid) {
      this.subSink.sink = this.individuService
        .getOrCreate(uid) // // fix TG-376 - cf. dans autre tâche d'optimisation TG-378 pour prochaine release
        .pipe(
          concatMap((_) => this.dossierSvc.contacts('add', this.dossier.uuid, uid)))
        .subscribe(
          (data: Dossiers) => {
            this.snackSvc.toasty('Contacts', 'contact bien ajouté', typeToast.success);
            this.dossier.contacts = data.contacts;
            this.dossier.contacts_obj = data.contacts_obj;
          });
    } else {
      this.snackSvc.toasty('Ajout de contact', 'Vous êtes déjà le demandeur ou en contact', typeToast.info);
    }
  }
  deleteContact(ind: Individu) {
    const data = new DialogData();
    data.title = 'Enlever un contact';
    data.message = `Vous êtes sur le point de supprimer le contact <strong>${ind.last_name} ${ind.first_name}</strong>.
                    <br/>Confirmez-vous la suppression ?`;

    const dialogRef = this.dialog.open(DialogValidationComponent, { data: data });
    dialogRef.updatePosition({top: '50px'});
    dialogRef.afterClosed().pipe(
        filter(result => !!result),
        switchMap(() => this.dossierSvc.contacts('delete', this.dossier.uuid, ind.uid)
          .pipe(
            tap(_data => {
              this.dossier.contacts = _data.contacts;
              this.dossier.contacts_obj = _data.contacts_obj;
            }),
            finalize(() => this.snackSvc.toasty('Contacts', 'contact bien enlevé', typeToast.success)))
      )).subscribe();
  }
}
